var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("售后订单")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: {
              cascaderValue: _vm.handlerCascaderValue,
              formDataval: _vm.dialogClick,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _vm._m(0),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.settingAddress },
                    },
                    [_vm._v("退货地址设置")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columns.config,
              typeStr: _vm.columns.type,
            },
            on: {
              applyDialog: _vm.applyDialog,
              lookDialog: _vm.lookDialog,
              optionDialog: _vm.optionDialog,
              tableSelectionChange: _vm.tableSelectionChange,
            },
          }),
          _c(
            "div",
            {
              staticClass: "page",
              staticStyle: { padding: "10px 10px", float: "right" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.currentPage,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退货地址",
            visible: _vm.dialogTableVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("退货地址管理"),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.gridData, border: "" } },
            [
              _c("el-table-column", {
                attrs: { property: "name", label: "收货人姓名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入收货人姓名" },
                          model: {
                            value: scope.row.name,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "name", $$v)
                            },
                            expression: "scope.row.name",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { property: "phone", label: "收货人电话", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入收货人电话" },
                          model: {
                            value: scope.row.phone,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "phone", $$v)
                            },
                            expression: "scope.row.phone",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { property: "address", label: "收货地址" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入收货地址" },
                          model: {
                            value: scope.row.address,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "address", $$v)
                            },
                            expression: "scope.row.address",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { property: "address", label: "操作", width: "80px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteAddress(scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("添加")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApplyDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApplyDialog = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("是否审核通过"),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "1" },
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                [_vm._v("通过")]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: "2" },
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                [_vm._v("驳回")]
              ),
            ],
            1
          ),
          _vm.radio == 2
            ? _c(
                "div",
                { staticStyle: { display: "flex", "margin-top": "10px" } },
                [
                  _c("div", [_vm._v("备注")]),
                  _c(
                    "div",
                    { staticStyle: { width: "90%", "margin-left": "10px" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          rows: 3,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.remark,
                          callback: function ($$v) {
                            _vm.remark = $$v
                          },
                          expression: "remark",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.radio == 1
            ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v("选择退货地址"),
              ])
            : _vm._e(),
          _vm.radio == 1
            ? _c(
                "el-table",
                {
                  attrs: { data: _vm.gridData, border: "" },
                  on: { "row-click": _vm.rowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "select", width: "50" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: scope.row.id },
                                  model: {
                                    value: _vm.radioIdSelect,
                                    callback: function ($$v) {
                                      _vm.radioIdSelect = $$v
                                    },
                                    expression: "radioIdSelect",
                                  },
                                },
                                [_vm._v(" ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3374867373
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "收货人姓名", width: "200" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "收货人电话", width: "200" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "收货地址" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isApplyDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveApply()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.dialogForm,
                    "label-width": "80px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流公司", prop: "logisticsCompany" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择物流公司",
                            filterable: "",
                          },
                          model: {
                            value: _vm.dialogForm.logisticsCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "logisticsCompany", $$v)
                            },
                            expression: "dialogForm.logisticsCompany",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.courier_company,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流单号", prop: "logisticsNumber" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入物流单号" },
                        model: {
                          value: _vm.dialogForm.logisticsNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm, "logisticsNumber", $$v)
                          },
                          expression: "dialogForm.logisticsNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "物流信息",
            visible: _vm.dialogLook,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLook = $event
            },
          },
        },
        [
          _c("StepLogistics", {
            attrs: { stepProgress: _vm.logisticsMessage },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLook = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLook = false
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("h3", [_vm._v("列表数据")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }